import { render, staticRenderFns } from "./LegInformation.vue?vue&type=template&id=41b4ea55&scoped=true"
import script from "./LegInformation.vue?vue&type=script&lang=js"
export * from "./LegInformation.vue?vue&type=script&lang=js"
import style0 from "./LegInformation.vue?vue&type=style&index=0&id=41b4ea55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b4ea55",
  null
  
)

export default component.exports